import React from 'react';
const HOTMART = 'https://checkout.recursostop.shop/cart/45770493690052:1';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/tFJL4uL94T5umLRnPNPjGW/ChatGPT_Image_13_feb_2026,_10_53_39.png';
export function HeroSection() {
  return <section className="bg-[#faf5ef] py-16 md:py-24 px-4" data-id="element-105">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-106">
        <p className="animate-in inline-flex items-center justify-center gap-3 text-green-700/80 font-semibold text-sm tracking-[0.2em] uppercase mb-8" data-id="element-107">
          <span className="w-10 h-px bg-green-400/50" data-id="element-108"></span>
          🌿 Aprende, Armoniza y Sana
          <span className="w-10 h-px bg-green-400/50" data-id="element-109"></span>
        </p>

        <h1 className="animate-in delay-100 mb-10" data-id="element-110">
          <span className="block text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight leading-[0.9]" data-id="element-111">
            <span className="text-gray-900" data-id="element-112">Mega</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 via-amber-600 to-amber-500" data-id="element-113">
              Pack
            </span>
          </span>
          <span className="block text-3xl md:text-4xl lg:text-5xl font-serif italic text-gray-600 mt-3" data-id="element-114">
            Reiki
          </span>
        </h1>

        <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="animate-scale-in delay-200 block mx-auto max-w-md md:max-w-lg mb-12 cursor-pointer group" data-id="element-115">
          <div className="relative" data-id="element-116">
            <div className="absolute -inset-6 bg-gradient-to-br from-amber-300/30 via-yellow-200/20 to-green-200/20 rounded-3xl blur-2xl opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-117"></div>
            <div className="relative bg-gradient-to-br from-amber-100 via-white to-amber-50 p-3 md:p-4 rounded-2xl shadow-[0_8px_60px_rgba(217,119,6,0.15)] group-hover:shadow-[0_12px_70px_rgba(217,119,6,0.25)] transition-all duration-500" data-id="element-118">
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-amber-400/50 rounded-tl-2xl" data-id="element-119"></div>
              <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-amber-400/50 rounded-tr-2xl" data-id="element-120"></div>
              <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-amber-400/50 rounded-bl-2xl" data-id="element-121"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-amber-400/50 rounded-br-2xl" data-id="element-122"></div>
              <img src={PRODUCT_IMG} alt="MegaPack Reiki - Camino Integral del Reiki" className="w-full rounded-xl shadow-inner" data-id="element-123" />
            </div>
          </div>
        </a>

        <h2 className="animate-in delay-300 text-xl md:text-2xl font-serif font-bold text-gray-800 mb-5" data-id="element-124">
          Formación completa lista para iniciar
        </h2>

        <p className="animate-in delay-400 text-base md:text-lg text-gray-500 mb-8 leading-relaxed max-w-xl mx-auto" data-id="element-125">
          Todo el material de Reiki que necesitas, ordenado, claro y listo para
          usar, para comenzar tu camino de sanación personal o acompañar a
          otros.
        </p>

        <div className="animate-fade delay-500 flex flex-wrap justify-center gap-6 mb-10 text-gray-600 font-semibold text-base" data-id="element-126">
          <span data-id="element-127">✔ Sin tecnicismos</span>
          <span data-id="element-128">✔ Sin cursos eternos</span>
        </div>

        <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="animate-in delay-600 cta-btn inline-block px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all" data-id="element-129">
          👉 SÍ, QUIERO ACCEDER AHORA
        </a>

        <p className="animate-fade delay-800 mt-4 text-green-600 font-medium text-sm" data-id="element-130">
          ✅ Garantía de satisfacción de 7 días
        </p>
      </div>
    </section>;
}